(function () {
  var elements = document.querySelectorAll('.fw-change');
  elements.forEach(function (element) {
    var text = element.innerHTML;
    var split = text.split(' '); // separate the text by spaces

    var first = split.shift(); // drop the first word and store it in a variable

    if (first.indexOf("<i>") >= 0) {
      //added to account for if the first element is a font awesome icon. If it's a font awesome icon, return the text
      element.innerHTML = text;
    } else {
      //otherwise join the text back and if it has more than 1 word add the span tag to the first word
      element.innerHTML = '<span class="first">' + first + '</span> ' + split.join(" ");
    }
  });
})();